import { render, staticRenderFns } from "./ConfigPanel.vue?vue&type=template&id=10b407a1&scoped=true&"
import script from "./ConfigPanel.vue?vue&type=script&lang=js&"
export * from "./ConfigPanel.vue?vue&type=script&lang=js&"
import style0 from "./ConfigPanel.vue?vue&type=style&index=0&id=10b407a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b407a1",
  null
  
)

export default component.exports